import { jsx as a, Fragment as s } from "react/jsx-runtime";
import { Children as i, isValidElement as y } from "react";
const m = ({ children: o, invalidChildren: r = [] }) => {
  const n = r.map((e) => e.toLowerCase()), p = i.toArray(o).filter((e) => {
    let t;
    return y(e) ? (typeof e.type == "string" ? t = e.type : typeof e.type == "object" && typeof e.type.displayName == "string" ? t = e.type.displayName : typeof e.type == "function" && (t = e.type.displayName ?? e.type.name), t && n.includes(t.toLowerCase()) ? (console.warn(
      `Filtering out ${t} because [${r.join(", ")}] are not allowed in this component.`
    ), !1) : !0) : !0;
  });
  return /* @__PURE__ */ a(s, { children: p });
};
export {
  m as ChildFilter
};
//# sourceMappingURL=index.js.map
